import { useSeatPlanStore } from "@/stores/v2/seatPlanStore";
import { useClassroomLayoutStore } from "@/stores/v2/classroomLayoutStore";
import { Personalisation } from "@/stores/classroomStore_I";
import { SeatRosterStudent, sortSeatRosterIds } from "./seatLayout";

const TILE_WIDTH_PX_MIN = 150;
const TILE_WIDTH_PX_MAX = 350;

export function tileScaleFromTileWidth(tileWidth: number): number {
	const raw = (tileWidth - TILE_WIDTH_PX_MIN) / (TILE_WIDTH_PX_MAX - TILE_WIDTH_PX_MIN);
	if (Number.isNaN(raw)) return 0;
	if (raw < 0) return 0;
	if (raw > 1) return 1;
	return raw;
}

// Seed layout stores from classroom.personalisation on GetClass/GetGroup.
export function hydrateClassroomPersonalisation(
	personalisation: Partial<Personalisation> | null | undefined,
	students: SeatRosterStudent[]
): void {
	const rosterIds = sortSeatRosterIds(students);

	// Auto-sort is always last name. Ignore personalisation.studentSortOrder from the backend.
	useSeatPlanStore.getState().setLayoutSortOrder("lastNameAscending");

	// Same reason for the grid itself: the store is a global singleton, so start every class from the
	// roster-derived default (DEFAULT_COLUMNS x ceil(students / columns)) rather than inheriting the
	// previous class's columns/rows/cardWidth. A saved layout is applied over this below.
	useSeatPlanStore.getState().hydrate(null, rosterIds);

	const tileWidth = personalisation?.tileWidth;
	if (typeof tileWidth === "number" && tileWidth > 0) {
		const scale = tileScaleFromTileWidth(tileWidth);
		useClassroomLayoutStore.getState().setDefaultTileScale(scale);
		useSeatPlanStore.getState().setCardWidth(tileWidth);
	}

	const customLayout = personalisation?.customLayout;
	const hasGrid =
		typeof customLayout?.columns === "number" && customLayout.columns > 0 && typeof customLayout.rows === "number" && customLayout.rows > 0;
	if (hasGrid) {
		const slots = customLayout.slots.map((s) => (s === "" ? null : s));
		// Marked custom first so `hydrate` keeps the saved empty seats instead of packing them away.
		useSeatPlanStore.getState().setLayoutSortOrder("custom");
		useSeatPlanStore.getState().hydrate(
			{
				slots,
				columns: customLayout.columns,
				rows: customLayout.rows,
				cardWidth: useSeatPlanStore.getState().cardWidth,
			},
			rosterIds
		);
	}
}
